import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { GlobalContext } from './context/globalContext';
import { store } from './redux/store';
// import { ForumProvider } from './pages/contentmodration/ForumContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store} >
   <GlobalContext>
   {/* <ForumProvider> */}
    <App />
    {/* </ForumProvider> */}
  </GlobalContext>
  </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
